<template><div /></template>

<script>
import store from '@/store';
import { logWebHrError } from "@/core/logger/log-wrapper";

export default {
  name: 'document-download-module-dms',
  props: {
    tenantId: {
      type: String,
      default: undefined,
    },
    employeeId: {
      type: String,
      default: undefined,
    },
    documentId: {
      type: String,
      default: undefined,
    },
    tempToken: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    async function initialize() {
      try {
        await store.dispatch(
          'dispatchSetupAuthDms',
          props.tempToken,
          props.documentId
        );

        const { data } = await store.dispatch('getDocSignatureFromDms', {
          tenantId: props.tenantId,
          employeeId: props.employeeId,
          documentId: props.documentId,
        });

        downloadFile(data.name, data.content);
      } catch (e) {
        alert(e);
        logWebHrError({
          message: 'Failed to initialise at document download module',
          source: 'document-download-module-dms',
          metadata: {
            tenantId: props.tenantId,
            employeeId: props.employeeId,
            documentId: props.documentId,
          },
          error: e,
        });
      }
    }

    function downloadFile(fileName, url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      link.remove();
    }

    initialize();
    return;
  },
};
</script>
